import {
  VISIT_SUBSCRIPTION_PAGE,
  UNSET_SUBSCRIPTION_VISIT,
  SELECT_SUBSCRIPTION_PLAN,
} from 'Redux/Types/SubscribeTypes'

import { SUBSCIPTION_PLAN_CODES } from 'Constants'

const { PRO } = SUBSCIPTION_PLAN_CODES

const INITIAL_STATE = {
  visited: false,
  selectedPlan: PRO,
}

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case UNSET_SUBSCRIPTION_VISIT:
      return {
        ...state,
        visited: false,
      }
    case VISIT_SUBSCRIPTION_PAGE:
      return {
        ...state,
        visited: true,
      }
    case SELECT_SUBSCRIPTION_PLAN:
      return {
        ...state,
        selectedPlan: payload,
      }

    default:
      return state
  }
}
